import { NodeType } from 'shared/types/ingestion'
import { IConfig } from '../types'

const WarmUpActivityConfig: Record<string, IConfig> = {
  'Building on': {
    type: NodeType.SkillsList,
    includes: ['Activity|Building on'],
  },
  Addressing: {
    type: NodeType.SkillsList,
    includes: ['Activity|Addressing'],
  },
  'Building Towards': {
    type: NodeType.SkillsList,
    includes: ['Activity|Building Towards'],
  },
  Narrative: {
    type: NodeType.Note,
    includes: ['Warm-up|Narrative'],
  },
  'Access for Students with Disabilities/English Learners': {
    type: NodeType.Note,
    includes: [
      'Warm-up|Access for Students with Disabilities/English Learners',
    ],
  },
  'Materials to Copy': {
    type: NodeType.Note,
    includes: ['Warm-up|Materials to Copy'],
  },
  'Required Materials': {
    type: NodeType.Note,
    includes: ['Warm-up|Required Materials'],
  },
  'Required Preparation': {
    type: NodeType.Note,
    includes: ['Warm-up|Required Preparation'],
  },
  'Time Frame': {
    type: NodeType.Note,
    includes: ['Warm-up|Time Frame'],
  },
  'Learning Goals - Teacher': {
    type: NodeType.Note,
    includes: ['Learning Goals - teacher'],
    studentFacing: true,
  },
  'Learning Goals': {
    type: NodeType.Note,
    includes: ['Learning Goals - student'],
    studentFacing: true,
  },
  'Instructional Routines': {
    type: NodeType.Note,
    includes: ['Warm-up|Instructional Routines'],
  },
  'Warm-up': {
    type: NodeType.Note,
    includes: ['Warm-up|Purpose'],
  },
  Launch: {
    type: NodeType.Note,
    includes: ['Warm-up|Launch'],
  },
  Activity: {
    type: NodeType.Note,
    includes: ['Warm-up|Activity'],
  },
  'Advanced Student Thinking': {
    type: NodeType.Note,
    includes: ['Warm-up|Advanced Student Thinking'],
  },
  'Anticipated Misconceptions': {
    type: NodeType.Note,
    includes: ['Activity|Anticipated Misconceptions'],
  },
  Questions: {
    type: NodeType.Question,
    includes: ['Warm-up|Questions', 'Warm-up|Question'],
    teacherNotes: ['Warm-up|Note for Evaluating Responses'],
  },
  'Activity Synthesis': {
    type: NodeType.Note,
    includes: ['Warm-up|Activity Synthesis'],
  },
}

export const BaseActivityConfig: Record<string, IConfig> = {
  'Building on': {
    type: NodeType.SkillsList,
    includes: ['Activity|Building on'],
  },
  Addressing: {
    type: NodeType.SkillsList,
    includes: ['Activity|Addressing'],
  },
  'Building Towards': {
    type: NodeType.SkillsList,
    includes: ['Activity|Building Towards'],
  },
  Narrative: {
    type: NodeType.Note,
    includes: ['Activity|Narrative'],
  },
  'Access for Students with Disabilities/English Learners': {
    type: NodeType.Note,
    includes: [
      'Activity|Access for Students with Disabilities/English Learners',
    ],
  },
  'Materials to Copy': {
    type: NodeType.Note,
    includes: ['Activity|Materials to Copy'],
  },
  'Required Materials': {
    type: NodeType.Note,
    includes: ['Activity|Required Materials'],
  },
  'Required Preparation': {
    type: NodeType.Note,
    includes: ['Activity|Required Preparation'],
  },
  'Time Frame': {
    type: NodeType.Note,
    includes: ['Activity|Time Frame'],
  },
  'Instructional Routines': {
    type: NodeType.Note,
    includes: ['Activity|Instructional Routines'],
  },
  Purpose: {
    type: NodeType.Note,
    includes: ['Activity|Purpose'],
  },
  Launch: {
    type: NodeType.Note,
    includes: ['Activity|Launch'],
  },
  'Activity Narrative': {
    type: NodeType.Note,
    includes: ['Activity|Activity Narrative'],
  },
  'Advanced Student Thinking': {
    type: NodeType.Note,
    includes: ['Activity|Advanced Student Thinking'],
  },
  Activity: {
    type: NodeType.Note,
    includes: ['Activity|Activity'],
  },
  Questions: {
    type: NodeType.Question,
    includes: [
      'Activity|Student Facing Task Questions',
      'Activity|Student Facing Task Statement',
      'Activity|Student Facing Task Statements',
      'Activity|Student Facing Task Question',
      'Activity|Student Facing Task Statement/Questions',
      'Activity|Student Facing Questions',
      'Activity|Student Facing Question',
    ],
    teacherNotes: ['Activity|Note for Evaluating Responses'],
  },
  'Activity Synthesis': {
    type: NodeType.Note,
    includes: ['Activity|Activity Synthesis'],
  },
}

const LessonSynthesisActivityConfig: Record<string, IConfig> = {
  'Lesson Synthesis': {
    type: NodeType.Note,
    includes: ['Lesson Synthesis'],
  },
}

const CoolDownActivityConfig: Record<string, IConfig> = {
  'Building on': {
    type: NodeType.SkillsList,
    includes: ['Cool-down|Building on'],
  },
  Addressing: {
    type: NodeType.SkillsList,
    includes: ['Cool-down|Addressing'],
  },
  'Building Towards': {
    type: NodeType.SkillsList,
    includes: ['Cool-down|Building Towards'],
  },
  Launch: {
    type: NodeType.Note,
    content: '',
  },
  Question: {
    type: NodeType.Question,
    includes: [
      'Cool-down|Student-facing Task Statement',
      'Cool-down|Student Facing Task Statement/Questions',
      'Cool-down|Student Facing Task Questions',
      'Cool-down|Student Facing Task Statements',
      'Cool-down|Student Facing Task Question',
      'Cool-down|Student Facing Questions',
      'Cool-down|Student Facing Question',
    ],
    teacherNotes: ['Cool-down|Note for Evaluating Responses'],
  },
  'Responding to Student Thinking': {
    type: NodeType.Note,
    content: '',
  },
}

const StudentLessonSummaryActivityConfig: Record<string, IConfig> = {
  'Student Lesson Summary': {
    type: NodeType.Note,
    content: '',
  },
}

const PracticeProblemsActivityConfig: Record<string, IConfig> = {
  Activity: {
    type: NodeType.Question,
    includes: ['Practice Problems|Activity'],
    teacherNotes: ['Practice Problems|Student Responses'],
    practiceProblems: false,
  },
}

export const BaseLessonConfig: Record<string, IConfig> = {
  'Building on': {
    type: NodeType.SkillsList,
    includes: ['Building on'],
  },
  Addressing: {
    type: NodeType.SkillsList,
    includes: ['Addressing', 'Standards', 'ADDRESSING STANDARD'],
  },
  'Building Towards': {
    type: NodeType.SkillsList,
    includes: ['Building Towards'],
  },
  Presentation: {
    type: NodeType.NodeList,
  },
  'Learning Goals': {
    type: NodeType.Note,
    includes: [
      'Learning Goals - teacher',
      'Learning goals (teacher facing)',
      'LEARNING GOALS',
    ],
  },
  'Student Facing Learning Goals': {
    type: NodeType.Note,
    includes: [
      'Learning Goals - student',
      'Learning goals (student facing)',
      'STUDENT FACING LEARNING GOALS',
    ],
    studentFacing: true,
  },
  'Learning Targets': {
    type: NodeType.Note,
    includes: ['Learning Targets'],
    studentFacing: true,
  },
  'Lesson Purpose': {
    type: NodeType.Note,
    includes: ['Lesson Purpose', 'Purpose'],
  },
  'Lesson Narrative': {
    type: NodeType.Note,
    includes: ['Narrative', 'Lesson Narrative'],
  },
  'Instructional Routines': {
    type: NodeType.Note,
    includes: ['Instructional Routines', 'Routines'],
  },
  'Required Materials': {
    type: NodeType.Note,
    includes: ['Required Materials|Materials to Gather', 'Required Materials'],
  },
  'Materials to Copy': {
    type: NodeType.Note,
    includes: ['Required Materials|Materials To Copy', 'Materials to Copy'],
  },
  'Required Preparation': {
    type: NodeType.Note,
    includes: ['Required Materials|Required Preparation'],
  },
  'Lesson Timeline': {
    type: NodeType.Note,
    includes: ['Lesson Timeline'],
  },
  'Teacher Reflection': {
    type: NodeType.Note,
    includes: ['Teacher Reflection Questions', 'Teacher Reflection'],
  },
  'Suggested Centers': {
    type: NodeType.Note,
    includes: ['Suggested Centers'],
  },
  Activities: {
    type: NodeType.NodeList,
    nodes: [
      {
        title: 'Warm-up',
        type: NodeType.Activity,
        config: WarmUpActivityConfig,
      },
      {
        title: 'Activity',
        type: NodeType.Activity,
        config: BaseActivityConfig,
        multiple: true,
      },
      {
        title: 'Lesson Synthesis',
        type: NodeType.Activity,
        config: LessonSynthesisActivityConfig,
      },
      {
        title: 'Cool-down',
        type: NodeType.Activity,
        config: CoolDownActivityConfig,
      },
      // {
      //   title: 'Student Lesson Summary',
      //   type: NodeType.Activity,
      //   config: StudentLessonSummaryActivityConfig,
      // },
      {
        title: 'Practice Problems',
        type: NodeType.Activity,
        config: PracticeProblemsActivityConfig,
      },
    ],
  },
}

export const requiredLessonHeaders = [
  'ADDRESSING STANDARD',
  'ADDRESSING STANDARDS',
  'LEARNING GOALS',
  'LEARNING GOALS (TEACHER FACING)',
  'LEARNING GOALS (STUDENT FACING)',
  'STUDENT FACING LEARNING GOALS',
  'LESSON PURPOSE',
  'LESSON NARRATIVE',
  'INSTRUCTIONAL ROUTINES',
  'REQUIRED MATERIALS',
  'MATERIALS TO COPY',
  'LESSON TIMELINE',
  'TEACHER REFLECTION',
  'SUGGESTED CENTERS',
]
